class IngridDeliveryTracking extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    const script = document.createElement('script')

    this.initialise = this.initialise.bind(this)
    this.privateSearch = this.privateSearch.bind(this)
    this.search = this.search.bind(this)
    this.handleScriptError = this.handleScriptError.bind(this)

    script.src = this.dataset.scriptUrl
    script.addEventListener('load', this.initialise)
    script.addEventListener('error', this.handleScriptError)

    document.head.appendChild(script)
  }

  initialise () {
    const params = new URLSearchParams(window.location.search)
    const identifier = params.get('identifier')
    const contact = params.get('contact')

    if (identifier && contact) {
      this.privateSearch(identifier, contact)
    } else {
      this.search()
    }
  }

  search () {
    window.IngridDeliveryTrackingWidgetApi.renderSearchMode({
      containerId: this.dataset.placementId,
      locale: this.dataset.locale,
      siteId: this.dataset.siteId,
    })
  }

  privateSearch (identifier, contact) {
    window.IngridDeliveryTrackingWidgetApi.renderPrivateMode({
      containerId: this.dataset.placementId,
      locale: this.dataset.locale,
      siteId: this.dataset.siteId,
      identifier,
      contact,
    })
  }

  handleScriptError () {
    this.hasError = true
  }
}

if (!customElements.get('ingrid-delivery-tracking')) {
  customElements.define('ingrid-delivery-tracking', IngridDeliveryTracking)
}
